export const COMPANY = {
  companyName:
    "Think5Whys Global DeepTech Solution Private Limited",

  address:
    "B-1402, Riviera, Casa Bella, Palava, Mumbai, Maharashtra, India - 421204",

  email: "onboarding@think5whys.com",

  whatsapp: "+91 9324342890",

  bankName: "HDFC Bank",

  branch: "Nilaje",

  accountNumber: "50200119544501",

  ifsc: "HDFC0009266",

  swift: "HDFCINBB",

  cin: "U62099MR2026PTC475677",

  pan: "AANCT0191M",

  pan: "PNET22637G",

  gst: "27AANCT0191M1ZT",

  dpiit: "DIPP260988",

  udyam: "UDYAM-MH-33-0764104"
};